export default [
    {
        path: '/customers',
        name: 'CustomersIndex',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Customers',
        },
        components: {
            default: () => import('@views/customers/CustomersIndex.vue'),
        },
    },
    {
        path: '/customers/:id/view',
        name: 'CustomersShow',
        props: {
            default: (route) => ({ id: route.params.id }),
        },
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Customer',
        },
        components: {
            default: () => import('@views/customers/CustomersShow.vue'),
        },
    },
];
